import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { httpToastInterceptor } from './core/interceptors/http-toast.interceptor';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideToastr } from 'ngx-toastr';
import { MaterialModule } from './material.module';

import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { deleteInterceptor } from './core/interceptors/confirm-delete.interceptor';

export const appConfig: ApplicationConfig = {
  // providers: [
  //   provideBrowserGlobalErrorListeners(),
  //   provideZoneChangeDetection({ eventCoalescing: true }),
  //   provideRouter(routes),
  //   provideAnimationsAsync(),
  // ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding(),
    ),
    provideHttpClient(
      withInterceptors([
        authTokenInterceptor,
        httpToastInterceptor,
        deleteInterceptor,
      ]),
      withInterceptorsFromDi(),
    ),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      TablerIconsModule.pick(TablerIcons),

      //NgxStripeModule.forRoot(environment.STRIPE_PUBLISHABLE_KEY)
    ),
  ],
};
